/**
 * Authorization event types for real-time notifications and durable event recording.
 */
export enum AuthorizationEventType {
  POLICY_CREATED = 'authorization:policy-created',
  POLICY_UPDATED = 'authorization:policy-updated',
  POLICY_DELETED = 'authorization:policy-deleted',
  AUDIT_LOGGED = 'authorization:audit-logged',
}

/**
 * Pub/sub channel for authorization events.
 */
export const AUTHORIZATION_EVENTS_CHANNEL = 'authorization:events';